<template>
  <ul>
    <template v-if="hasMessages">
      <MessageItem
        v-for="(message, idx) in messages"
        :key="message.id"
        :message="message"
        :last="idx === messages.length - 1"
      />
    </template>
    <li v-else>There are no messages yet.</li>
  </ul>
</template>

<script>
import MessageItem from './MessageItem.vue';

export default {
  components: { MessageItem },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasMessages() {
      return this.messages.length > 0;
    },
  },
};
</script>
